/**
 * New Zealand dollar.
 */
export var NZD = {
  code: 'NZD',
  base: 10,
  exponent: 2
};